import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const React = require("react");
export const Announcement = (props)=>{
    const home = props.homepage;
    if (home == 'loading' || home == 'error' || !home.announcement || !home.showAnnouncement) return /*#__PURE__*/ _jsx(_Fragment, {});
    return /*#__PURE__*/ _jsx("div", {
        className: "announcement",
        role: "alert",
        children: /*#__PURE__*/ _jsx("div", {
            className: "container--mg align--center",
            children: /*#__PURE__*/ _jsx("div", {
                className: "announcement__inner text--styled",
                dangerouslySetInnerHTML: {
                    __html: home.announcement
                }
            })
        })
    });
};
